<script>

import SimpleButtonCta from "./SimpleButtonCta.vue"
import ProgressButtonCta from "./ProgressButtonCta.vue";

export default {
    name: "GenericButtonCta",
    components: {SimpleButtonCta, ProgressButtonCta},
    props: {
        dtoFromJson: {
            type: String,
            required: false,
            default: ""
        },
        dtoFromObject: {
            type: Object,
            required: false,
            default: undefined
        },
        cssClasses: {
            type: String,
            required: false,
            default: "btn-primary"
        },
        ariaLabel: {
          type: String,
          required: false,
          default: null
        }
    },
    computed: {
        /**
         * @returns {GenericButtonCtaDto}
         */
        dto() {
            return typeof this.dtoFromObject === "object" && this.dtoFromObject || JSON.parse(this.dtoFromJson);
        },
        isProgressButtonCta() {
            return this.dto.dataTimer !== undefined
        },
        progressButtonCta() {
            return this.dto
        },
        simpleButtonCta() {
            return this.dto
        }
    }
}

</script>

<template>
    <div>
        <progress-button-cta
            v-if="isProgressButtonCta"
            :button-label="progressButtonCta.buttonLabel"
            :desktop-button-label="progressButtonCta.desktopButtonLabel"
            :action-http-method="progressButtonCta.actionHttpMethod"
            :action-url="progressButtonCta.actionUrl"
            :action-form-params="progressButtonCta.actionFormParams"
            :action-json-form-params="progressButtonCta.actionJsonFormParams"
            :data-timer="progressButtonCta.dataTimer"
            :tms-dto="progressButtonCta.tmsDto"
            :redirect-url-on-action-functional-errors="progressButtonCta.redirectUrlOnActionFunctionalErrors"
            :redirect-url-on-action-technical-errors="progressButtonCta.redirectUrlOnActionTechnicalErrors"
            :css-classes="cssClasses"
            :aria-label="ariaLabel"
        />

        <simple-button-cta
            v-else
            :tms-data="simpleButtonCta.tmsDto"
            :action-url="simpleButtonCta.actionUrl"
            :action-form-params="simpleButtonCta.actionFormParams"
            :button-label="simpleButtonCta.buttonLabel"
            :desktop-button-label="simpleButtonCta.desktopButtonLabel"
            :css-classes="cssClasses"
            :aria-label="ariaLabel"
            :is-modal-opener="simpleButtonCta.modalOpener"
        />
    </div>
</template>
